import * as actionTypes from './actionTypes';
import { brandVehicleTopService } from './services';

const fetchbrandVehicleTopRequest = () => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_TOP_REQUEST
});

const fetchbrandVehicleTopSuccess = (data) => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_TOP_SUCCESS,
  data
});

const fetchbrandVehicleTopFailure = () => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_TOP_FAILURE
});

export const fetchBrandVehicleTop = (vehicleId: number, flag?: string): Function => {
  return async dispatch => {
    dispatch(fetchbrandVehicleTopRequest());
    try {
      const data = await brandVehicleTopService.get(vehicleId, flag);
      dispatch(fetchbrandVehicleTopSuccess(data));
    } catch (e) {
      dispatch(fetchbrandVehicleTopFailure());
    }
  }
};
